import React, { useState } from "react"
import { navigate } from "gatsby"
import axios from "axios"
import Modal from "react-bootstrap/Modal"
import OtpInput from "react18-input-otp"
import { useToasts } from "react-toast-notifications"
import ProceedButton from "./ProceedButton"

const OTP = (props) => {
  const { addToast } = useToasts()
  const [otp, setOtp] = useState("")
  const [message, setMessage] = useState("")
  const [messageColor, setMessageColor] = useState("")
  const [state, setState] = useState({
    isButtonDisabled: false,
  })
  const [btnLoading, setBtnloading] = useState(false)
  const handleClose = () => {
    setOtp("")
    props.closePopup()
  }

  const handleChange = (enteredOtp) => setOtp(enteredOtp)

  const verifyOtp = async () => {
    setBtnloading(true)
    axios
      .get(
        `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/token?nuban=${props.account}&otp=${otp}`
      )
      .then((res) => {
        localStorage.setItem("nuban_id_24b854967", props.account)
        localStorage.setItem("mobile_token", res.data.data.token)
        navigate(`${props.path}`)

        setBtnloading(false)

        setOtp("")
      })
      .catch((err) => {
        addToast(err.response.data.message, {
          appearance: "error",
          placement: "top-center",
          autoDismiss: true,
        })
        setBtnloading(false)
      })
  }

  const startLogin = async () => {
    await fetch(`${process.env.DIY_BASE_URL}/api/account/v1/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        email: process.env.DIY_EMAIL,
        password: process.env.DIY_PASSWORD,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        localStorage.setItem("6d361f1d1c1160c1f", process.env.SUPPORT_TOKEN)
        localStorage.setItem("nuban_id_24b854967", props.account)
        localStorage.setItem("dd_token", response.token)
        navigate(`/business-support/mobile-business-reg/start`)
      })
      .catch((error) => {
        setMessage(error.message)
        return []
      })
  }

  return (
    <div>
      <Modal size="lg" show={props.show} centered>
        <Modal.Body className="p-0 rounded-20 position-relative">
          <span
            aria-label="close"
            className="modal-close-btn"
            onClick={handleClose}
            onKeyDown={handleClose}
            role="button"
            tabIndex={0}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.41425 6.00001L11.7072 1.70701C12.0982 1.31601 12.0982 0.684006 11.7072 0.293006C11.3162 -0.0979941 10.6842 -0.0979941 10.2933 0.293006L6.00025 4.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L4.58625 6.00001L0.29325 10.293C-0.09775 10.684 -0.09775 11.316 0.29325 11.707C0.48825 11.902 0.74425 12 1.00025 12C1.25625 12 1.51225 11.902 1.70725 11.707L6.00025 7.41401L10.2933 11.707C10.4882 11.902 10.7443 12 11.0002 12C11.2562 12 11.5122 11.902 11.7072 11.707C12.0982 11.316 12.0982 10.684 11.7072 10.293L7.41425 6.00001Z"
                fill="black"
              ></path>
            </svg>
          </span>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <h2 className="text-center font-weight-bold mt-5 sparkle--color__light">
                  OTP Validation
                </h2>

                <p className="sparkle--color__light text-center mt-3">
                  Input the security code sent to your device with your Sparkle
                  Account.
                </p>

                <p className={`small mt-3 text-center ${messageColor}`}>
                  {message}
                </p>

                <form className="kwes-form waitlist__form my-lg-5 my-3">
                  <div className="form-row justify-content-center">
                    <div className="col">
                      <OtpInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={6}
                        separator={<span>-</span>}
                        inputStyle="form-control inputStyle"
                        containerStyle="form-row justify-content-center"
                      />
                    </div>
                  </div>

                  <ProceedButton
                    handleClick={() => verifyOtp()}
                    disable={otp.length < 6}
                    text="Proceed"
                    type="button"
                    btnloading={btnLoading}
                  />

                  <div className="form-row justify-content-center mt-2">
                    <div className="col-lg-8">
                      <p className="sparkle--color__light text-center mt-1">
                        I didn’t receive OTP,{" "}
                        {state.isButtonDisabled ? (
                          <span className="sparkle-green">
                            Try again in 15 secs.
                          </span>
                        ) : (
                          <span
                            className="sparkle-green cursor"
                            onClick={() => {
                              props.requestNewOtp(props.account)
                              setOtp("")
                              setState({
                                isButtonDisabled: true,
                              })
                              setTimeout(
                                () => setState({ isButtonDisabled: false }),
                                15000
                              )
                            }}
                          >
                            <b>Send Again</b>
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default OTP
